const stats = [
  { value: '500+', label: 'Businesses Participating' },
  { value: '$0', label: 'Enrollment cost' },
  
  { value: '2 plans', label: 'Tailored by team size' }
];

function BrandMark() {
  return (
    <span className="logo-mark brand-mark" aria-hidden="true">
      <i className="fa-solid fa-location-dot brand-location-icon" />
    </span>
  );
}

export default function HeroSection() {
  const currentPageUrl = typeof window !== 'undefined' ? window.location.href : '#';

  return (
    <header className="hero-ecec text-white pb-5 pb-lg-6">
      <nav className="navbar navbar-dark py-2 hero-navbar">
        <div className="container-fluid hero-nav-container">
          <div className="navbar-brand brand-link d-flex align-items-center gap-2 gap-sm-3 text-decoration-none" >
            <BrandMark />
            <div className="brand-copy text-start">
              <span className="logo-text d-block mb-0">Early Childhood Education Association</span>
              <span className="logo-textt d-block">of Colorado</span>
            </div>
          </div>
          <span className="small text-white-50 member-program-label">Member-Exclusive Program</span>
        </div>
      </nav>

      <div className="hero-inner container text-center  ">
        <p className="badge-program d-inline-block mb-4 load-fade-up">VR Health Savings Program</p>
        <h1 className="font-serif fw-bold display-5 display-md-4 mb-3 text-white load-fade-up delay-1">
          Real health benefits,
          <br />
          <span className="text-ecec-gold fst-italic">real savings</span> for your team
        </h1>
        <p className="text-white-50 mx-auto mb-5 hero-copy load-fade-up delay-2">
          Colorado child care providers deserve great benefits without the big price tag. ECEA's exclusive program works with
partners to bring you health savings designed for teams of every size.
        </p>

        <div className="hero-stats d-flex flex-wrap justify-content-center text-center px-2 load-fade-up delay-3">
          {stats.map((stat, index) => (
            <div
              className="stat"
              key={stat.label}
            >
              <div className="stat-value">{stat.value}</div>
              <p className="stat-label">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </header>
  );
}
